import React from "react";
import styled from "styled-components";
import mapValues from "lodash/mapValues";
import { useTranslation } from "react-i18next";
import ArchiveBackendDeletionForm from "archive/components/ArchiveBackendDeletionForm";
import { DEFAULT_PAGE_SIZE, PAGE_SIZES } from "archive/hooks/useArchivesQuery";
import { LinkContainer, EntityList, EntityListItem, PaginatedList } from "components/common";
import { Button, Col, DropdownButton, Row, DeleteMenuItem } from "components/bootstrap";
import { ConfigurationWell } from "components/configurationforms";
import AppConfig from "util/AppConfig";
import ButtonToolbar from "components/bootstrap/ButtonToolbar";
import { BACKEND_TYPES } from "../ArchiveStore";
import ArchiveRoutes from "../Routes";
const isCloud = AppConfig.isCloud();
const StyledRow = styled(Row)`
  dt {
    float: left;
    width: 200px;
    overflow: hidden;
    clear: left;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  dd {
    margin-left: 180px;
    display: inline-block;
  }

  dl {
    margin-bottom: 0;
  }
`;
const ArchiveBackendWrapper = styled.div`
  .entity-list,
  .alert {
    margin-top: 10px;
  }
`;
const ArchiveBackends = ({ backends, pagination, onDelete, onPageChange = void 0 }) => {
  const { t } = useTranslation("enterprise_archive");
  const deletionModals = {};
  const _onDelete = (backend) => () => {
    if (backend.id && deletionModals[backend.id]) {
      deletionModals[backend.id].open();
    }
  };
  const formatBackend = (backend) => {
    const { settings, description, id, title } = backend;
    const actions = !isCloud && /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: ArchiveRoutes.BACKENDS.show(id) }, /* @__PURE__ */ React.createElement(Button, null, t("archive_backends.edit"))), /* @__PURE__ */ React.createElement(
      DropdownButton,
      {
        title: t("archive_backends.more_actions"),
        id: `backend-dropdown-${id || "newbackend"}`,
        pullRight: true
      },
      /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: _onDelete(backend) })
    ));
    const normalizedSettings = mapValues(settings, (value, key) => {
      if (key === "type") {
        return BACKEND_TYPES[settings[key]];
      }
      if (["aws_secret_access_key", "key"].includes(key)) {
        return "***********";
      }
      return value;
    });
    const content = /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement(ConfigurationWell, { id, configuration: normalizedSettings })), /* @__PURE__ */ React.createElement(
      ArchiveBackendDeletionForm,
      {
        ref: (c) => {
          deletionModals[id || "newbackend"] = c;
        },
        backend,
        onDelete
      }
    ))));
    return /* @__PURE__ */ React.createElement(
      EntityListItem,
      {
        key: `backend-${id || "newbackend"}`,
        title,
        description,
        actions,
        contentRow: content
      }
    );
  };
  return /* @__PURE__ */ React.createElement(ArchiveBackendWrapper, null, /* @__PURE__ */ React.createElement("h2", null, t("archive_backends.title"), /* @__PURE__ */ React.createElement("span", null, "\xA0", /* @__PURE__ */ React.createElement("small", null, t("archive_backends.total", { total: pagination.total })))), /* @__PURE__ */ React.createElement("p", { className: "description archive-backends-description" }, t("archive_backends.description")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizes: PAGE_SIZES,
      totalItems: pagination.total,
      onChange: onPageChange,
      showPageSizeSelect: false
    },
    /* @__PURE__ */ React.createElement(
      EntityList,
      {
        bsNoItemsStyle: "info",
        noItemsText: t("archive_backends.no_items"),
        items: backends.map((backend) => formatBackend(backend))
      }
    )
  )));
};
export default ArchiveBackends;
